/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DataPageOfVital } from '../models/data-page-of-vital';
import { Vital } from '../models/vital';
import { vitalGetGraphForVital } from '../fn/vital/vital-get-graph-for-vital';
import { VitalGetGraphForVital$Params } from '../fn/vital/vital-get-graph-for-vital';
import { vitalGetGrowthChart } from '../fn/vital/vital-get-growth-chart';
import { VitalGetGrowthChart$Params } from '../fn/vital/vital-get-growth-chart';
import { vitalList } from '../fn/vital/vital-list';
import { VitalList$Params } from '../fn/vital/vital-list';

@Injectable({ providedIn: 'root' })
export class VitalService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `vitalList()` */
  static readonly VitalListPath = '/vitals/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vitalList()` instead.
   *
   * This method doesn't expect any request body.
   */
  vitalList$Response(params?: VitalList$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfVital>> {
    return vitalList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vitalList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vitalList(params?: VitalList$Params, context?: HttpContext): Observable<DataPageOfVital> {
    return this.vitalList$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfVital>): DataPageOfVital => r.body)
    );
  }

  /** Path part for operation `vitalGetGraphForVital()` */
  static readonly VitalGetGraphForVitalPath = '/vital/graph';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vitalGetGraphForVital()` instead.
   *
   * This method doesn't expect any request body.
   */
  vitalGetGraphForVital$Response(params?: VitalGetGraphForVital$Params, context?: HttpContext): Observable<StrictHttpResponse<Vital>> {
    return vitalGetGraphForVital(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vitalGetGraphForVital$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vitalGetGraphForVital(params?: VitalGetGraphForVital$Params, context?: HttpContext): Observable<Vital> {
    return this.vitalGetGraphForVital$Response(params, context).pipe(
      map((r: StrictHttpResponse<Vital>): Vital => r.body)
    );
  }

  /** Path part for operation `vitalGetGrowthChart()` */
  static readonly VitalGetGrowthChartPath = '/vital/growthChart';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vitalGetGrowthChart()` instead.
   *
   * This method doesn't expect any request body.
   */
  vitalGetGrowthChart$Response(params?: VitalGetGrowthChart$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return vitalGetGrowthChart(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vitalGetGrowthChart$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vitalGetGrowthChart(params?: VitalGetGrowthChart$Params, context?: HttpContext): Observable<Blob> {
    return this.vitalGetGrowthChart$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
